import $axiosProtected from "../../common/utils/axiosUtils";

export const createForm = async (payload: any) => {
  return await $axiosProtected().post("/vitals/forms/store", payload);
};
